import { render, staticRenderFns } from "./MyIcons.vue?vue&type=template&id=e504e5ba&scoped=true"
var script = {}
import style0 from "./MyIcons.vue?vue&type=style&index=0&id=e504e5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e504e5ba",
  null
  
)

export default component.exports